import React from 'react'
export interface TagSelectProps {
  tags: string[]
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  className?: string
  allowEmptyValue?: boolean
  listClassName?: string
}
const TagSelect: React.FC<TagSelectProps> = (props) => {
  const {
    tags,
    value,
    onChange,
    disabled,
    allowEmptyValue,
    className = '',
    listClassName = '',
  } = props
  return (
    <ul
      className={cls`
        bg-f-other-1 flex flex-wrap items-start gap-1.5 rounded-lg
        ${disabled ? 'cursor-not-allowed' : ''}
        ${className}
      `}
    >
      {tags.map((tag) => {
        const checked = value === tag
        return (
          <li
            key={tag}
            onClick={() => {
              if (!disabled) {
                if (allowEmptyValue) {
                  onChange?.(tag === value ? '' : tag)
                } else {
                  onChange?.(tag)
                }
              }
            }}
            className={cls`
              text-f-text-tertiary
              hover:text-f-text border-f-border-secondary
              inline-flex w-auto rounded-[10px] border px-2 py-1 text-xs md:px-3 md:py-2
              md:text-sm
              ${checked && !disabled && '!text-f-text primary-btn font-normal'}
              ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
              ${listClassName}
            `}
          >
            {tag}
          </li>
        )
      })}
    </ul>
  )
}
export default TagSelect
